import React from "react";
import { ColorInfoContext } from "../components/context/color-info-context";
var DefaultColorInfo = {
  isInverted: false,
  color: '#000000',
  backgroundColor: '#FFFFFF'
};
export var useColorInfo = function useColorInfo() {
  return React.useContext(ColorInfoContext) || DefaultColorInfo;
};